export default "__VITE_ASSET__CO3BZEhe__"